import { Link } from "react-router-dom";
import { EnrolledCourse } from "@/hooks/useEnrolledCourses";
import { CourseCard } from "./CourseCard";
import { useTranslation } from "react-i18next";

interface CourseGridProps {
  courses: EnrolledCourse[];
  loading: boolean;
  lang?: string;
}

export function CourseGrid({ courses, loading, lang = "en" }: CourseGridProps) {
  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (courses.length === 0) {
    return (
      <div className="card-enhanced bg-card rounded-lg overflow-hidden p-6 text-center">
        <p className="text-muted-foreground mb-4">You're not enrolled in any courses yet.</p>
        <Link
          to={`/${lang === 'en' ? '' : lang + '/'}courses`}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Browse Courses
        </Link>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {courses.map((course) => (
        <CourseCard key={course.slug} course={course} />
      ))}
    </div>
  );
}
